import type { MonitorSpec, MonitorType } from './types';
import { isAnalyticsMonitor } from './types';

export const MONITOR_SPECS: MonitorSpec[] = [
	{
		type: { metric_type: 'freshness' },
		iconName: 'clockPlay',
		title: 'Freshness',
		group: 'Table',
		description: 'Monitors the time elapsed since last update.',
	},
	{
		type: { metric_type: 'row_count' },
		iconName: 'layoutRows',
		title: 'Row Count',
		group: 'Table',
		description: 'Monitors the number of rows over time.',
	},
	{
		type: { metric_type: 'cardinality' },
		iconName: 'columns2',
		title: 'Cardinality',
		group: 'Column',
		description: 'Monitors the number of distinct values in a column.',
	},
	{
		type: { metric_type: 'max' },
		iconName: 'hash',
		title: 'Max',
		group: 'Column',
		description: 'Monitors the maximum of all values in a column.',
	},
	{
		type: { metric_type: 'mean' },
		iconName: 'hash',
		title: 'Mean',
		group: 'Column',
		description: 'Monitors the average of all values in a column.',
	},
	{
		type: { metric_type: 'min' },
		iconName: 'hash',
		title: 'Minimum',
		group: 'Column',
		description: 'Monitors the minimum of all values in a column.',
	},
	{
		type: { metric_type: 'null_percentage' },
		iconName: 'percentage',
		title: 'Null Percentage',
		group: 'Column',
		description: 'Monitors the percentage of values in a column that are null.',
	},
	{
		type: { metric_type: 'unique_percentage' },
		iconName: 'percentage',
		title: 'Unique Percentage',
		group: 'Column',
		description:
			'Monitors the percentage of values in a column that are unique.',
	},
	{
		type: { metric_type: 'custom_sql' },
		iconName: 'code',
		title: 'Custom SQL',
		group: 'Custom',
		description: 'Define a monitor using custom SQL.',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'bigquery_compute_cost',
		},
		iconName: 'coin',
		title: 'BigQuery compute cost',
		group: 'Warehouse',
		description: 'Monitors the compute costs incurred of a BigQuery project.',
		integrationType: 'bigquery',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'bigquery_storage_cost',
		},
		iconName: 'coin',
		title: 'BigQuery storage cost',
		group: 'Warehouse',
		description: 'Monitors the storage costs incurred of a BigQuery project.',
		integrationType: 'bigquery',
	},
	{
		type: { metric_type: 'analytics', integration_metric: 'snowflake_cost' },
		iconName: 'coin',
		title: 'Snowflake cost',
		group: 'Warehouse',
		description: 'Monitors the costs incurred of a Snowflake warehouse.',
		integrationType: 'snowflake',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'snowflake_query_volume',
		},
		iconName: 'database',
		title: 'Snowflake query volume',
		description:
			'Monitors the number of queries executed against a Snowflake integration.',
		group: 'Warehouse',
		integrationType: 'snowflake',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'snowflake_compute_usage',
		},
		iconName: 'businessplan',
		title: 'Snowflake compute credits',
		description: 'Monitors the compute credit usage of a Snowflake warehouse.',
		group: 'Warehouse',
		integrationType: 'snowflake',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'snowflake_storage_usage',
		},
		iconName: 'businessplan',
		title: 'Snowflake storage usage',
		description: 'The storage usage of a Snowflake database.',
		group: 'Warehouse',
		integrationType: 'snowflake',
	},
	{
		type: {
			metric_type: 'analytics',
			integration_metric: 'dbt_model_execution_time',
		},
		iconName: 'clockPlay',
		title: 'Model Execution Time',
		group: 'Analytics',
		description: 'Monitors the execution time of dbt models from run results.',
		integrationType: 'dbt',
	},
	{
		type: { metric_type: 'job_duration' },
		iconName: 'clockPlay',
		title: 'Job duration',
		group: 'Pipeline',
		description:
			'Monitors the time taken for jobs to complete from start to finish. Helps identify performance trends and potential bottlenecks in your workflows.',
	},
	{
		type: { metric_type: 'job_success_rate' },
		iconName: 'clipboardCheck',
		title: 'Job success rate',
		group: 'Pipeline',
		description:
			'Tracks the percentage of jobs that complete successfully. Helps maintain reliability by monitoring the overall health of your job executions.',
	},
	{
		type: { metric_type: 'job_error_rate' },
		iconName: 'doorEnter',
		title: 'Job error rate',
		group: 'Pipeline',
		description:
			'Measures the frequency of job failures and errors. Essential for identifying problematic jobs and maintaining system reliability.',
	},
	// {
	// 	type: { metric_type: 'analytics', integration_metric: 'dbt_test_warnings' },
	// 	iconName: 'alertTriangle',
	// 	title: 'dbt test warnings',
	// 	description:
	// 		'Monitors the number of failed dbt tests across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
	// {
	// 	type: { metric_type: 'analytics', integration_metric: 'dbt_test_skips' },
	// 	iconName: 'playerSkipForward',
	// 	title: 'dbt test skips',
	// 	description:
	// 		'Monitors the number of successful dbt tests across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
	// {
	// 	type: { metric_type: 'analytics', integration_metric: 'dbt_test_errors' },
	// 	iconName: 'exclamationMark',
	// 	title: 'dbt test errors',
	// 	description:
	// 		'Monitors the number of dbt test warnings across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
	// {
	// 	type: { metric_type: 'analytics', integration_metric: 'dbt_test_passes' },
	// 	iconName: 'check',
	// 	title: 'dbt test passes',
	// 	description: 'The number of successful dbt tests across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
	// {
	// 	type: { metric_type: 'analytics', integration_metric: 'dbt_test_failures' },
	// 	iconName: 'x',
	// 	title: 'dbt test failures',
	// 	description: 'The number of failed dbt tests across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
	// {
	// 	type: {
	// 		metric_type: 'analytics',
	// 		integration_metric: 'dbt_test_execution_times',
	// 	},
	// 	iconName: 'x',
	// 	title: 'dbt test execution time',
	// 	description: 'The execution time of dbt tests across a table or column.',
	// 	group: 'Tests',
	// 	integrationType: 'dbt',
	// },
];

export const getMonitorSpec = (type: MonitorType): MonitorSpec => {
	const spec = MONITOR_SPECS.find(
		(s) =>
			s.type.metric_type === type.metric_type &&
			(isAnalyticsMonitor(type) && isAnalyticsMonitor(s.type)
				? s.type.integration_metric === type.integration_metric
				: true)
	);
	if (!spec) {
		return {
			type,
			iconName: 'database',
			title: type.metric_type,
			group: 'Custom',
			description: 'Custom monitor',
		};
	}
	return spec;
};
